import React from 'react';
import RootAPP from './routes/routes';
import './i18n';
import { ThemeProvider } from './themeContext';
import { Toaster } from 'sonner';

const App = () => {
  const time = process.env.REACT_APP_NOTIFICATION_TIME;

  return (
    <>
      <ThemeProvider>
        <RootAPP />
      </ThemeProvider>
      <Toaster position="top-right" richColors duration={Number(time)} expand closeButton/>
    </>
  );
}

export default App;
